var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "pdf", staticClass: "pdf-file" },
    _vm._l(_vm.pageTotal, function (page) {
      return _c(
        "div",
        { key: page, staticClass: "pdf-page", class: { debug: !_vm.working } },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("favorites.title")) +
                  " - " +
                  _vm._s(_vm.$t("favorites.category." + _vm.activeTab)) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "items" },
              _vm._l(_vm.chunks[page - 1], function (chunk, i) {
                return _c("div", { key: i, staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n            " + _vm._s(chunk.name) + "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumbnail" },
                    [
                      chunk.image
                        ? _c("img", { attrs: { src: chunk.image } })
                        : _c("default-logo", { staticClass: "item-image" }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.slice(chunk.description, 500) || "N/A") +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "note" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("favorites.pdf.note"))),
                      ]),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.slice(chunk.note, 200) || "N/A") +
                          "\n            "
                      ),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pager" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("favorites.pdf.pager", { page, total: _vm.pageTotal })
                ) +
                "\n    "
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }